import { ReminderQuery } from 'data-ng-personal-reminders';

export class MyTodoReminderDetailController {
  constructor(
    private $state: ng.ui.IStateService,
    private ngReminderQuery: ReminderQuery
  ) {}

  goToEditReminder = () => {
    this.$state.go('my.newreminder', {
      personalTodoID: this.ngReminderQuery.result.id
    });
  };
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todo_reminder_details/my_todo_reminder_details_controller.ts